import React, { useState, useEffect } from 'react';

// 💥 当前登录玩家ID（核心：用于判断市场物品是不是自己的）
const CURRENT_USER = 'Funky_8848';

// ===================== 📦 中央超级资料库 =====================
const masterItems = [
  { id: 'a1', type: '头像', name: '墨镜狗', img: '😎', basePrice: 200 },
  { id: 'a2', type: '头像', name: '金芥末', img: '🌭', basePrice: 150 },
  { id: 'f1', type: '头像框', name: '波普黑框', img: '🔲', basePrice: 300 },
  { id: 's1', type: '贴纸', name: '经典美式', img: '🇺🇸', basePrice: 50 },
  { id: 's2', type: '贴纸', name: '芝士玉米', img: '🌽', basePrice: 50 },
  { id: 's3', type: '贴纸', name: '纽约肉酱', img: '🥩', basePrice: 50 },
  { id: 's4', type: '贴纸', name: '德州烤肉', img: '🥓', basePrice: 50 },
  { id: 'c1', type: '卡片', name: '口味全图鉴', img: '🃏', basePrice: 800, condition: '集齐所有口味贴纸解锁' },
  { id: 'c2', type: '卡片', name: '签到王者', img: '📅', basePrice: 300, condition: '累计打卡照片7次解锁' },
  { id: 'c4', type: '卡片', name: '放克领主', img: '💎', basePrice: 1500, condition: '会员达到Lv.4解锁' },
  { id: 't1', type: '票券', name: '试吃(单颗)', img: '🍡', basePrice: 80 },
  { id: 't2', type: '票券', name: '试吃(整份)', img: '🥡', basePrice: 150 },
  { id: 't3', type: '票券', name: '8折券', img: '🎫', basePrice: 200 },
  { id: 't4', type: '票券', name: '7折神券', img: '🎟️', basePrice: 400 },
  { id: 't5', type: '票券', name: '经营许可证', img: '📜', basePrice: 100, desc: '增加挂单机会' },
  { id: 'frag1', type: '碎片', name: '【单颗试吃】', img: '🧩', basePrice: 30, reqFrag: 3 },
  { id: 'frag2', type: '碎片', name: '【8折券】', img: '🧩', basePrice: 50, reqFrag: 5 },
];

const marketListings = [
  { id: 'lst1', type: '卡片', name: '口味全图鉴', price: 1200, seller: '高玩_X', sellerId: 'user_x', img: '🃏', tradeType: 'sell', stall: 2, daysLeft: 2, canExtend: true },
  { id: 'lst2', type: '票券', name: '8折券', price: 180, seller: '萌新_Y', sellerId: 'user_y', img: '🎫', tradeType: 'sell', stall: 5, daysLeft: 1, canExtend: false },
  { id: 'lst3', type: '贴纸', name: '纽约肉酱', price: 60, seller: '吃货_Z', sellerId: 'user_z', img: '🥩', tradeType: 'buy', stall: 1, daysLeft: 3, canExtend: true },
  // 模拟自己上架的
  { id: 'lst4', type: '碎片', name: '【单颗试吃】', price: 40, seller: '放克原住民', sellerId: CURRENT_USER, img: '🧩', tradeType: 'sell', stall: 10, daysLeft: 2, canExtend: true },
];

const exchangeStore = [
  { id: 'ex_s1', type: '贴纸', name: '经典美式', img: '🇺🇸', reqFrag: 4, fragName: '【美式】碎片', limit: 99, exchanged: 0 },
  { id: 'ex_s2', type: '贴纸', name: '芝士玉米', img: '🌽', reqFrag: 4, fragName: '【玉米】碎片', limit: 99, exchanged: 0 },
  { id: 'ex_t1', type: '票券', name: '一口肠试吃', img: '🍡', reqFrag: 3, fragName: '【一口肠】碎片', limit: 1, exchanged: 1 }, 
  { id: 'ex_t3', type: '票券', name: '8折神券', img: '🎫', reqFrag: 5, fragName: '【8折券】碎片', limit: 1, exchanged: 0 }, 
  { id: 'ex_f1', type: '头像框', name: '波普黑框', img: '🔲', reqFrag: 10, fragName: '【波普框】碎片', limit: 1, exchanged: 0 },
];

const dummyInventory = [
  { id: 'inv1', type: '贴纸', name: '经典美式', img: '🇺🇸', count: 2 },
  { id: 'inv2', type: '票券', name: '经营许可证', img: '📜', count: 1 },
];

const categories = ['头像', '头像框', '贴纸', '卡片', '票券', '碎片'];

function Community() {
  const [viewState, setViewState] = useState('home'); 
  const [activeTab, setActiveTab] = useState('社区商店'); 
  const [sysCategory, setSysCategory] = useState('贴纸'); 
  const [freeMarketMode, setFreeMarketMode] = useState('sell'); 
  
  const [buyModal, setBuyModal] = useState(null); 
  const [exchangeModal, setExchangeModal] = useState(null);
  
  const [showUploadModal, setShowUploadModal] = useState(false); 
  const [targetStall, setTargetStall] = useState(1); 
  const [uploadCategory, setUploadCategory] = useState('贴纸');
  const [selectedUploadItem, setSelectedUploadItem] = useState(null); 
  const [extendTimeChecked, setExtendTimeChecked] = useState(false); 

  const [activeGame, setActiveGame] = useState(null);
  const [slotResult, setSlotResult] = useState(['❓', '❓', '❓']);
  const [isSpinning, setIsSpinning] = useState(false);
  const [showPhotoUpload, setShowPhotoUpload] = useState(false);

  const playerInfo = { level: 2, quota: 2 }; 
  const getExtensionDays = (lvl) => {
    if (lvl >= 5) return '永久'; if (lvl === 4) return 10; if (lvl === 3) return 7; if (lvl === 2) return 5; if (lvl === 1) return 3; return 2; 
  };

  useEffect(() => {
    const jumpIntent = localStorage.getItem('jumpIntent');
    const marketUpload = localStorage.getItem('marketUpload');
    if (jumpIntent) {
      const intent = JSON.parse(jumpIntent);
      if (intent.action === 'exchange') {
        setViewState('market');
        setActiveTab('碎片兑换');
        const targetItem = exchangeStore.find(ex => ex.id === intent.targetId);
        if (targetItem) { setSysCategory(targetItem.type); setTimeout(() => setExchangeModal(targetItem), 100); }
      }
      localStorage.removeItem('jumpIntent');
    }
    if (marketUpload) {
      setViewState('market');
      setActiveTab('自由集市');
      setFreeMarketMode('sell');
      setShowUploadModal(true);
      localStorage.removeItem('marketUpload');
    }
  }, []);

  const renderGridSlots = (items, isFreeMarket) => {
    const slots = [...items];
    let hasAddedPlus = false;
    while (slots.length < 16) { 
      if (isFreeMarket && !hasAddedPlus) {
        slots.push({ isPlusBtn: true, id: 'upload-btn' });
        hasAddedPlus = true;
      } else {
        slots.push({ isEmpty: true, id: `empty-${slots.length}` }); 
      }
    }
    return slots.slice(0, 16); 
  };

  const renderStalls = () => {
    const currentListings = marketListings.filter(item => item.tradeType === freeMarketMode);
    const stalls = [];
    for (let i = 1; i <= 16; i++) {
      const itemInStall = currentListings.find(x => x.stall === i);
      if (itemInStall) {
        stalls.push(
          <div key={i} onClick={() => setBuyModal(itemInStall)} style={{ border: '2px solid black', background: itemInStall.sellerId === CURRENT_USER ? '#ffebee' : '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, background: itemInStall.sellerId === CURRENT_USER ? '#ff5252' : 'black', color: 'white', fontSize: '8px', padding: '1px 3px', fontWeight: 'bold' }}>{i}号</div>
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '24px' }}>{itemInStall.img}</div>
            <div style={{ fontSize: '9px', fontWeight: '900', textAlign: 'center', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', background: '#f0f0f0', borderTop: '1px solid black' }}>{itemInStall.name}</div>
            <div style={{ background: freeMarketMode === 'sell' ? '#E6B422' : '#ff5252', color: freeMarketMode === 'sell' ? 'black' : 'white', width: '100%', textAlign: 'center', fontSize: '10px', fontWeight: '900', borderTop: '1px solid black' }}>{itemInStall.price}🪙</div>
          </div>
        );
      } else {
        stalls.push(
          <div key={i} onClick={() => { setTargetStall(i); setSelectedUploadItem(null); setExtendTimeChecked(false); setShowUploadModal(true); }} style={{ border: '1px dashed #aaa', background: '#fcfcfc', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', position: 'relative' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, background: '#ddd', color: '#555', fontSize: '8px', padding: '1px 3px', fontWeight: 'bold' }}>{i}号</div>
            <div style={{ fontSize: '28px', color: '#ccc', fontWeight: '100', lineHeight: 1, marginTop: '-5px' }}>+</div>
            <div style={{ fontSize: '9px', fontWeight: 'bold', color: '#aaa', marginTop: '2px' }}>{freeMarketMode === 'sell' ? '上架' : '求购'}</div>
          </div>
        );
      }
    }
    return stalls;
  };

  const renderSystemSlots = () => {
    const sysItems = activeTab === '碎片兑换' ? exchangeStore.filter(item => item.type === sysCategory) : masterItems.filter(item => item.type === sysCategory);
    return renderGridSlots(sysItems, false).map((item, idx) => (
      item.isEmpty ? (
        <div key={`sys-emp-${idx}`} style={{ border: '1px dashed #ccc', background: '#f9f9f9' }}></div>
      ) : (
        <div key={item.id} onClick={() => activeTab === '碎片兑换' ? setExchangeModal(item) : setBuyModal({ ...item, tradeType: 'system' })} style={{ border: '2px solid black', background: activeTab === '碎片兑换' ? '#fff9e6' : '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', position: 'relative', overflow: 'hidden' }}>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '24px', filter: item.exchanged >= item.limit ? 'grayscale(100%) opacity(0.5)' : 'none' }}>{item.img}</div>
          <div style={{ fontSize: '9px', fontWeight: '900', textAlign: 'center', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', background: '#f0f0f0', borderTop: '1px solid black' }}>{item.name}</div>
          <div style={{ background: activeTab === '碎片兑换' ? '#000' : '#E6B422', color: activeTab === '碎片兑换' ? '#fff' : '#000', width: '100%', textAlign: 'center', fontSize: '9px', fontWeight: '900', borderTop: '1px solid black' }}>
            {activeTab === '碎片兑换' ? `需 ${item.reqFrag} 碎` : (item.condition ? '🔒需解锁' : `${item.basePrice}🪙`)}
          </div>
          {item.exchanged >= item.limit && <div style={{ position: 'absolute', top: '10px', background: '#555', color: 'white', fontSize: '8px', padding: '2px 5px', transform: 'rotate(-15deg)', fontWeight: 'bold', border: '1px solid white' }}>已达上限</div>}
        </div>
      )
    ));
  };

  const playSlotMachine = () => {
    setIsSpinning(true);
    let count = 0;
    const interval = setInterval(() => {
      const emojis = ['🍅', '🌽', '🥩', '🥓', '🎫', '🍡', '🧩', '🔲'];
      setSlotResult([emojis[Math.floor(Math.random()*8)], emojis[Math.floor(Math.random()*8)], emojis[Math.floor(Math.random()*8)]]);
      count++;
      if (count > 10) {
        clearInterval(interval);
        setSlotResult(['🧩', '🧩', '🧩']); 
        setIsSpinning(false);
        setTimeout(() => alert('🎉 恭喜获得：【8折券】碎片 x1！已存入背包。'), 500);
      }
    }, 100);
  };

  // 返回大厅按钮 (放大)
  const BackButton = ({ onClick }) => (
    <button onClick={onClick} style={{ background: 'black', color: 'white', padding: '12px', fontSize: '16px', fontWeight: '900', marginBottom: '10px', border: '3px solid #E6B422', boxShadow: '2px 2px 0 #E6B422', borderRadius: '8px', cursor: 'pointer', flexShrink: 0 }}>
      ⬅ 返回社区大厅
    </button>
  );

  // ===================== 全局路由视图 =====================
  if (viewState === 'home') {
    return (
      <div style={{ padding: '10px', height: '100%', display: 'flex', flexDirection: 'column', gap: '15px', overflow: 'hidden', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', fontWeight: '900', fontSize: '24px', margin: '5px 0', WebkitTextStroke: '1px black', color: '#fff', textShadow: '2px 2px 0 #000' }}>🌐 放克大社区</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', flex: 1, paddingBottom: '10px', overflowY: 'auto' }}>
          <div onClick={() => setViewState('market')} style={{ border: '4px solid black', background: '#E6B422', display: 'flex', alignItems: 'center', padding: '15px 20px', boxShadow: '4px 4px 0 #000', cursor: 'pointer' }}>
            <div style={{ fontSize: '40px', marginRight: '20px', filter: 'drop-shadow(2px 2px 0px #000)' }}>🛒</div>
            <div><h2 style={{ margin: '0 0 5px 0', fontWeight: '900', fontSize: '22px' }}>社区集市</h2><div style={{ fontSize: '12px', fontWeight: 'bold' }}>自由交易 · 官方兑换所</div></div>
          </div>
          <div onClick={() => setViewState('arcade')} style={{ border: '4px solid black', background: '#00E676', display: 'flex', alignItems: 'center', padding: '15px 20px', boxShadow: '4px 4px 0 #000', cursor: 'pointer' }}>
            <div style={{ fontSize: '40px', marginRight: '20px', filter: 'drop-shadow(2px 2px 0px #000)' }}>🎰</div>
            <div><h2 style={{ margin: '0 0 5px 0', fontWeight: '900', fontSize: '22px' }}>放克游戏厅</h2><div style={{ fontSize: '12px', fontWeight: 'bold' }}>游玩赢碎片 · 赚取海量积分</div></div>
          </div>
          <div onClick={() => setViewState('photowall')} style={{ border: '4px solid black', background: '#ff5252', color: 'white', display: 'flex', alignItems: 'center', padding: '15px 20px', boxShadow: '4px 4px 0 #000', cursor: 'pointer' }}>
            <div style={{ fontSize: '40px', marginRight: '20px', filter: 'drop-shadow(2px 2px 0px #000)' }}>📸</div>
            <div><h2 style={{ margin: '0 0 5px 0', fontWeight: '900', fontSize: '22px' }}>热狗打卡墙</h2><div style={{ fontSize: '12px', fontWeight: 'bold', color: '#ffebee' }}>🔥 周五会员日 双倍积分！</div></div>
          </div>
          <div onClick={() => setViewState('manifesto')} style={{ border: '4px solid black', background: '#fff', display: 'flex', alignItems: 'center', padding: '15px 20px', boxShadow: '4px 4px 0 #000', cursor: 'pointer' }}>
            <div style={{ fontSize: '40px', marginRight: '20px', filter: 'drop-shadow(2px 2px 0px #ccc)' }}>📜</div>
            <div><h2 style={{ margin: '0 0 5px 0', fontWeight: '900', fontSize: '22px' }}>社区公约</h2><div style={{ fontSize: '12px', fontWeight: 'bold', color: '#666' }}>品牌宣言与法律规范</div></div>
          </div>
        </div>
      </div>
    );
  }

  if (viewState === 'photowall') return ( 
    <div style={{padding:'10px', height:'100%', display:'flex', flexDirection:'column', overflow: 'hidden'}}>
      <BackButton onClick={() => setViewState('home')} />
      <div style={{ border: '4px solid black', background: 'white', padding: '15px', flex: 1, display: 'flex', flexDirection: 'column', boxShadow: '4px 4px 0 #000', overflow: 'hidden' }}>
        <h2 style={{ fontWeight: '900', color: '#ff5252', textAlign: 'center', margin: '0 0 10px 0' }}>📸 打卡赚积分 (周五双倍)</h2>
        <div style={{ flex: 1, border: '2px solid black', background: '#fafafa', padding: '10px', overflowY: 'auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '15px' }}>
          {[1,2,3,4].map(i => (
            <div key={i} style={{ border: '2px dashed #aaa', background: '#fff', aspectRatio: '1/1', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ fontSize: '40px' }}>{['🌭','🍔','🍟','🥤'][i-1]}</div>
              <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#666', marginTop: '5px' }}>玩家_{i} 已打卡</div>
            </div>
          ))}
        </div>
        <button onClick={() => setShowPhotoUpload(true)} style={{ background: '#E6B422', border: '3px solid black', padding: '15px', fontWeight: '900', fontSize: '18px', width: '100%', flexShrink: 0 }}>+ 上传我的实物照</button>
        <div style={{ background: '#ffebee', border: '2px solid #ff5252', padding: '8px', marginTop: '10px', fontSize: '11px', color: '#b71c1c', flexShrink: 0 }}>
          <strong>🚨 警告与规范：</strong> 每天限1次。严禁盗图，违者删除并倒扣积分！
        </div>
      </div>
      {showPhotoUpload && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
          <div style={{ background: 'white', border: '4px solid black', width: '100%', maxWidth: '320px', padding: '20px', textAlign: 'center' }}>
            <h3 style={{ margin: '0 0 15px 0', fontWeight: '900' }}>调用系统相机/相册</h3>
            <div style={{ background: '#eee', border: '2px dashed black', height: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}><span style={{ fontSize: '50px' }}>📷</span></div>
            <button onClick={() => { alert('上传成功！审核通过后将获得 5 积分！'); setShowPhotoUpload(false); }} style={{ width: '100%', background: '#00E676', border: '3px solid black', padding: '12px', fontWeight: '900', fontSize: '16px', marginBottom: '10px' }}>确认上传</button>
            <button onClick={() => setShowPhotoUpload(false)} style={{ width: '100%', background: '#ccc', border: '3px solid black', padding: '12px', fontWeight: 'bold' }}>取消</button>
          </div>
        </div>
      )}
    </div> 
  );

  if (viewState === 'manifesto') return ( 
    <div style={{padding:'10px', height:'100%', display:'flex', flexDirection:'column', overflow: 'hidden'}}>
      <BackButton onClick={() => setViewState('home')} />
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ border: '4px solid black', background: 'white', padding: '20px', width: '90%', maxHeight: '80%', overflowY: 'auto', boxShadow: '8px 8px 0 #000' }}>
          <h1 style={{ fontWeight: '900', textAlign: 'center', marginBottom: '20px' }}>📜 放克社区公约</h1>
          <p style={{ fontWeight: 'bold', lineHeight: '1.6', fontSize: '14px' }}>欢迎来到最潮的放克街区！热狗不仅是美食，更是你的数字资产。</p>
          <hr style={{ borderTop: '2px dashed #ccc', margin: '20px 0' }}/>
          <h3 style={{ fontWeight: '900' }}>⚖️ 法律与合规警示</h3>
          <ul style={{ fontSize: '12px', color: '#555', lineHeight: '1.8', paddingLeft: '15px' }}>
            <li>资产解释权归本店所有。</li>
            <li>严禁线下非法现金交易、洗钱。</li>
            <li>积分仅供系统内循环，绝不支持提现。</li>
            <li>恶意利用漏洞套利者，随时清空资产。</li>
          </ul>
        </div>
      </div>
    </div> 
  );
  
  if (viewState === 'arcade') return ( 
    <div style={{padding:'10px', height:'100%', display:'flex', flexDirection:'column', overflow: 'hidden'}}>
      <BackButton onClick={() => { activeGame ? setActiveGame(null) : setViewState('home') }} />
      <div style={{ border: '4px solid black', background: '#222', color: 'white', padding: '15px', flex:1, display: 'flex', flexDirection: 'column', boxShadow: '4px 4px 0 #000' }}>
        <h2 style={{ fontWeight: '900', color: '#00E676', fontSize: '24px', textAlign: 'center', margin: '0 0 20px 0' }}>🎰 放克游戏大厅</h2>
        {!activeGame ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <div onClick={()=>setActiveGame('slots')} style={{ background: '#fff', color: '#000', border: '3px solid #E6B422', padding: '15px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
               <div style={{ fontSize: '40px', marginRight: '15px' }}>🎰</div>
               <div style={{ flex: 1 }}><div style={{ fontWeight: '900', fontSize: '18px' }}>经典老虎机</div><div style={{ fontSize: '12px', color: '#666' }}>保底掉落随机碎片</div></div>
               <div style={{ fontWeight: 'bold', color: '#ff5252' }}>-10 分/次</div>
            </div>
            <div onClick={()=>alert('刮刮乐即将上线！')} style={{ background: '#444', color: '#888', border: '3px dashed #666', padding: '15px', display: 'flex', alignItems: 'center', cursor: 'not-allowed' }}>
               <div style={{ fontSize: '40px', marginRight: '15px' }}>🎟️</div>
               <div style={{ flex: 1 }}><div style={{ fontWeight: '900', fontSize: '18px' }}>惊喜刮刮乐</div><div style={{ fontSize: '12px' }}>必出高级打折券</div></div>
               <div style={{ fontWeight: 'bold' }}>-20 分/次</div>
            </div>
          </div>
        ) : (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ display: 'flex', gap: '10px', background: 'black', padding: '20px', border: '5px solid #E6B422', borderRadius: '10px' }}>
              {slotResult.map((icon, i) => (
                <div key={i} style={{ width: '60px', height: '80px', background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '40px', border: '3px solid #555' }}>{icon}</div>
              ))}
            </div>
            <button onClick={playSlotMachine} disabled={isSpinning} style={{ background: isSpinning ? '#555' : '#ff5252', color: 'white', border: '4px solid black', padding: '15px 40px', fontSize: '20px', fontWeight: '900', marginTop: '40px', cursor: 'pointer', boxShadow: '0 5px 0 #000', borderRadius: '30px' }}>
              {isSpinning ? '抽取中...' : '摇一摇 (-10积分)'}
            </button>
          </div>
        )}
      </div>
    </div> 
  );

  // ===================== 🛒 核心：社区市场视图 (绝对防溢出) =====================
  return (
    <div style={{ padding: '0px 10px 10px 10px', height: '100%', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', overflow: 'hidden' }}>
      <BackButton onClick={() => setViewState('home')} />
      
      {/* 💥 修复：三大入口放大加粗 */}
      <div style={{ display: 'flex', border: '4px solid black', marginBottom: '8px', flexShrink: 0 }}>
        {['社区商店', '自由集市', '碎片兑换'].map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{ flex: 1, padding: '12px 0', fontSize: '15px', fontWeight: '900', border: 'none', borderRight: tab !== '碎片兑换' ? '3px solid black' : 'none', background: activeTab === tab ? 'black' : 'white', color: activeTab === tab ? 'white' : 'black', cursor: 'pointer' }}>
            {tab}
          </button>
        ))}
      </div>

      <div style={{ background: 'white', border: '4px solid black', borderRadius: '4px', padding: '6px', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', boxShadow: '4px 4px 0 rgba(0,0,0,0.1)' }}>
        {activeTab === '自由集市' ? (
          <div style={{ display: 'flex', marginBottom: '6px', border: '2px solid black', borderRadius: '4px', overflow: 'hidden', flexShrink: 0 }}>
            <button onClick={() => setFreeMarketMode('sell')} style={{ flex: 1, padding: '8px', background: freeMarketMode === 'sell' ? '#E6B422' : '#f0f0f0', fontWeight: '900', border: 'none', borderRight: '2px solid black', fontSize: '14px' }}>出售</button>
            <button onClick={() => setFreeMarketMode('buy')} style={{ flex: 1, padding: '8px', background: freeMarketMode === 'buy' ? '#ff5252' : '#f0f0f0', color: freeMarketMode === 'buy' ? 'white' : 'black', fontWeight: '900', border: 'none', fontSize: '14px' }}>求购</button>
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '6px', overflowX: 'auto', paddingBottom: '6px', marginBottom: '4px', flexShrink: 0 }}>
            {categories.map(cat => (
              <button key={cat} onClick={() => setSysCategory(cat)} style={{ padding: '4px 12px', fontSize: '12px', fontWeight: 'bold', border: '2px solid black', borderRadius: '20px', background: sysCategory === cat ? 'black' : 'white', color: sysCategory === cat ? 'white' : 'black', whiteSpace: 'nowrap' }}>{cat}</button>
            ))}
          </div>
        )}

        {/* 💥 核心修复：100% 高度 + repeat(4, minmax(0, 1fr))，网格如水一样自适应，无滚动条 */}
        <div style={{ flex: 1, minHeight: 0, display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gridTemplateRows: 'repeat(4, minmax(0, 1fr))', gap: '4px' }}>
          {activeTab === '自由集市' ? renderStalls() : renderSystemSlots()}
        </div>
      </div>

      {/* ===================== 💥 市场博弈交互弹窗 ===================== */}
      {buyModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
          <div style={{ background: 'white', border: '5px solid black', padding: '20px', width: '100%', maxWidth: '300px', boxShadow: '10px 10px 0 #E6B422', textAlign: 'center' }}>
            <div style={{ fontSize: '60px', marginBottom: '10px' }}>{buyModal.img}</div>
            <h2 style={{ margin: '0 0 5px 0', fontWeight: '900' }}>{buyModal.name}</h2>
            
            {buyModal.tradeType === 'system' ? (
              <div style={{ margin: '15px 0', padding: '10px', background: '#f0f0f0', border: '2px dashed black' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '12px', color: '#666' }}>社区商店</p>
                <p style={{ margin: 0, fontSize: '24px', color: '#E85A33', fontWeight: '900' }}>{buyModal.basePrice} 积分</p>
              </div>
            ) : (
              <div style={{ margin: '15px 0', padding: '10px', background: '#f0f0f0', border: '2px dashed black' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '12px', color: '#666' }}>{buyModal.tradeType === 'buy' ? '悬赏人' : '卖家'}: {buyModal.seller}</p>
                <p style={{ margin: 0, fontSize: '24px', color: buyModal.tradeType === 'buy' ? '#ff5252' : '#E85A33', fontWeight: '900' }}>{buyModal.price} 积分</p>
                
                {/* 💥 判定：是自己的单子，展示延时功能；别人的单子不展示 */}
                {buyModal.sellerId === CURRENT_USER && (
                  <div style={{ marginTop: '10px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
                    <span style={{ fontSize: '12px', color: '#555', fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>⏳ 剩余有效时间: {buyModal.daysLeft} 天</span>
                    {buyModal.canExtend ? (
                      <button onClick={() => { alert(`消耗 5 积分，根据特权已延长 ${getExtensionDays(playerInfo.level)} 天！`); setBuyModal(null); }} style={{ display: 'block', width: '100%', padding: '8px', background: '#00E676', border: '2px solid black', fontWeight: 'bold', fontSize: '12px' }}>+ 延长挂单 (-5分)</button>
                    ) : (
                      <button disabled style={{ display: 'block', width: '100%', padding: '8px', background: '#ccc', color: '#666', border: '2px solid #999', fontWeight: 'bold', fontSize: '12px' }}>已使用过加时特权</button>
                    )}
                  </div>
                )}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
              <button onClick={() => setBuyModal(null)} style={{ flex: 1, padding: '12px', background: '#ccc', border: '3px solid black', fontWeight: 'bold' }}>关闭</button>
              
              {/* 💥 判定：如果是别人的单子，才允许交易 */}
              {buyModal.sellerId !== CURRENT_USER && !buyModal.condition && (
                <button onClick={() => { alert('交易成功！背包数据已同步。'); setBuyModal(null); }} style={{ flex: 2, padding: '12px', background: buyModal.tradeType === 'buy' ? '#ff5252' : '#E6B422', color: buyModal.tradeType === 'buy' ? 'white' : 'black', border: '3px solid black', fontWeight: '900' }}>
                  {buyModal.tradeType === 'buy' ? '卖给他赚积分' : '立即购买扣除积分'}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {exchangeModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ background: 'white', border: '5px solid black', padding: '20px', width: '80%', maxWidth: '300px', boxShadow: '10px 10px 0 #00E676', textAlign: 'center' }}>
            <div style={{ fontSize: '60px', marginBottom: '10px', filter: exchangeModal.exchanged >= exchangeModal.limit ? 'grayscale(100%)' : 'none' }}>{exchangeModal.img}</div>
            <h2 style={{ margin: '0 0 5px 0', fontWeight: '900' }}>兑换 {exchangeModal.name}</h2>
            <div style={{ margin: '15px 0', padding: '10px', border: '2px dashed #E85A33', background: '#fff0e6' }}>
              <p style={{ margin: '0 0 5px 0', fontSize: '14px', fontWeight: 'bold' }}>消耗：{exchangeModal.reqFrag} 个 {exchangeModal.fragName}</p>
              {exchangeModal.limit < 99 && <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>本月配额: {exchangeModal.exchanged}/{exchangeModal.limit}</p>}
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setExchangeModal(null)} style={{ flex: 1, padding: '10px', background: '#ccc', border: '3px solid black', fontWeight: 'bold' }}>关闭</button>
              <button disabled={exchangeModal.exchanged >= exchangeModal.limit} onClick={() => { alert('已合成入包！'); setExchangeModal(null); }} style={{ flex: 2, padding: '10px', background: exchangeModal.exchanged >= exchangeModal.limit ? '#555' : '#00E676', color: exchangeModal.exchanged >= exchangeModal.limit ? '#aaa' : 'black', border: '3px solid black', fontWeight: '900' }}>
                {exchangeModal.exchanged >= exchangeModal.limit ? '本月已达上限' : '确认兑换'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 💥 发布上架/求购：内置微型背包系统 */}
      {showUploadModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
          <div style={{ background: 'white', border: '5px solid black', width: '100%', maxWidth: '340px', display: 'flex', flexDirection: 'column', boxShadow: '8px 8px 0 #000' }}>
            <div style={{ background: freeMarketMode === 'sell' ? '#E6B422' : '#ff5252', color: freeMarketMode === 'sell' ? 'black' : 'white', padding: '10px', textAlign: 'center', fontWeight: '900', fontSize: '16px', borderBottom: '3px solid black' }}>
              {freeMarketMode === 'sell' ? `📦 在 ${targetStall} 号发售` : `📢 在 ${targetStall} 号求购`}
            </div>
            
            <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              
              <div style={{ display: 'flex', gap: '5px', overflowX: 'auto', paddingBottom: '5px' }}>
                {categories.map(cat => (
                  <button key={cat} onClick={() => { setUploadCategory(cat); setSelectedUploadItem(null); }} style={{ padding: '3px 8px', fontSize: '12px', fontWeight: 'bold', border: '2px solid black', background: uploadCategory === cat ? 'black' : 'white', color: uploadCategory === cat ? 'white' : 'black', whiteSpace: 'nowrap' }}>{cat}</button>
                ))}
              </div>

              {/* 弹窗内部微型货架 */}
              <div style={{ background: '#f5f5f5', border: '2px solid #ccc', padding: '5px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '4px' }}>
                  {(() => {
                    const itemsToSelect = freeMarketMode === 'sell' ? dummyInventory : masterItems;
                    const list = itemsToSelect.filter(i => i.type === uploadCategory);
                    const slots = [...list];
                    while (slots.length < 8) slots.push({ isEmpty: true }); // 内置货架精简为8格
                    return slots.slice(0, 8).map((item, idx) => (
                      item.isEmpty ? (
                        <div key={`up-emp-${idx}`} style={{ border: '1px dashed #ccc', background: '#eee', aspectRatio: '1/1' }}></div>
                      ) : (
                        <div key={item.id} onClick={() => setSelectedUploadItem(item)} style={{ border: selectedUploadItem?.id === item.id ? '2px solid #ff5252' : '1px solid black', background: selectedUploadItem?.id === item.id ? '#ffebee' : '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', position: 'relative', aspectRatio: '1/1' }}>
                          <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px' }}>{item.img}</div>
                          <div style={{ fontSize: '8px', fontWeight: 'bold', textAlign: 'center', width: '100%', background: '#f0f0f0', borderTop: '1px solid black', whiteSpace: 'nowrap', overflow: 'hidden' }}>{item.name}</div>
                          {freeMarketMode === 'sell' && <div style={{ position: 'absolute', top: 0, right: 0, background: 'black', color: 'white', fontSize: '8px', padding: '0 3px' }}>x{item.count}</div>}
                        </div>
                      )
                    ));
                  })()}
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '5px' }}>
                <label style={{ fontWeight: '900', fontSize: '14px' }}>{freeMarketMode === 'sell' ? '标价' : '赏金'}:</label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input type="number" defaultValue="100" style={{ width: '80px', padding: '5px', border: '2px solid black', fontWeight: '900', fontSize: '16px', color: freeMarketMode === 'sell' ? '#E85A33' : '#ff5252', textAlign: 'right' }} />
                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>积分</span>
                </div>
              </div>

              <div style={{ background: '#f9f9f9', padding: '8px', border: '2px dashed #aaa', fontSize: '11px', color: '#444' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><strong>默认挂单：</strong> <span>3 天</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#ff5252', marginTop: '4px' }}><strong>手续费：</strong> <span>-5 分</span></div>
                
                {/* 加时选项 */}
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer', marginTop: '8px', background: '#ffebee', padding: '8px', border: '1px solid #ff5252' }}>
                  <input type="checkbox" checked={extendTimeChecked} onChange={(e) => setExtendTimeChecked(e.target.checked)} style={{ transform: 'scale(1.2)', marginTop: '2px' }} />
                  <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#b71c1c' }}>
                    + 延长挂单 (耗 5 积分) <br/>
                    <span style={{ fontSize: '9px', fontWeight: 'normal' }}>Lv.{playerInfo.level} 特权：可加时 {getExtensionDays(playerInfo.level)} 天</span>
                  </div>
                </label>
              </div>
            </div>

            <div style={{ display: 'flex', borderTop: '3px solid black' }}>
              <button onClick={() => setShowUploadModal(false)} style={{ flex: 1, padding: '12px', background: '#eee', border: 'none', borderRight: '3px solid black', fontWeight: '900', fontSize: '14px' }}>取消</button>
              <button onClick={() => { 
                if (!selectedUploadItem) { alert('请先在上方格子中选择物品！'); return; }
                alert(`扣除 ${extendTimeChecked ? 10 : 5} 积分！物品已发布。`); 
                setShowUploadModal(false); 
              }} style={{ flex: 2, padding: '12px', background: freeMarketMode === 'sell' ? '#E6B422' : '#ff5252', color: freeMarketMode === 'sell' ? 'black' : 'white', border: 'none', fontWeight: '900', fontSize: '14px' }}>
                确认发布 (-{extendTimeChecked ? 10 : 5}分)
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Community;